import styled from 'styled-components';
import { AllieText } from '../Text';

export const StyledRemainingText = styled(AllieText)`
  text-align: center;
`;

export const StyledSegmentContainer = styled.div`
  width: 100%;
  display: flex;
  background-color: var(--allie-color-white);

  border-radius: var(--allie-radius-xs);
  overflow: hidden;
  border: 1px solid var(--allie-color-neutral-30);

  .segment-button-indicator {
    --indicator-color: transparent !important;
    --indicator-color-checked: transparent !important;
  }

  ion-segment-button {
    height: 100%;
    min-width: unset;
    min-height: unset;
    --padding-end: 1px;
    --padding-start: 1px;
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 0;

    .segment-button-indicator {
      opacity: 0;
    }

    div {
      color: var(--allie-color-neutral-60);
    }

    button {
      background: var(--allie-color-white);
    }

    div svg path[fill]:not([fill='none']) {
      fill: var(--allie-color-neutral-60);
    }
  }

  .segment-button-checked {
    background-color: var(--allie-color-neutral-90);

    div svg path:not([fill]),
    div svg path[fill='none'] {
      stroke: var(--allie-color-white);
    }

    div svg path[fill]:not([fill='none']) {
      fill: var(--allie-color-white);
    }

    ion-icon {
      color: var(--allie-color-white);
    }
  }
`;
